import * as yup from 'yup'

import { hex } from 'Utils/yup-validations'
import { isSafe } from '../../../../../../../commonHelpers/validator'

const appearanceFormValidationSchema = yup
  .object({
    displayName: yup
      .string()
      .trim()
      .required('Display name is required')
      .min(3, 'Display name should contain at least ${min} characters')
      .max(250, 'Display name can contain maximum of ${max} characters'),
    brandColor: yup
      .string()
      .trim()
      .required('Brand color is required')
      .min(4, 'Invalid hex color')
      .test('hex', 'Invalid hex color', hex),
    textColor: yup.string().trim().required('Highlight color is required').oneOf(['dark', 'light']),
    showBadgeLabel: yup.boolean(),
    badgeLabel: yup.string().when('showBadgeLabel', {
      is: true,
      then: yup
        .string()
        .required('Label text is required')
        .test({
          name: 'checkIsSafe',
          exclusive: true,
          message: 'Badge label contains restricted characters',
          test: function (value) {
            return isSafe(value)
          }
        })
        .min(3, 'Badge label should contain at least ${min} characters')
        .max(240, 'Badge label can contain maximum of ${max} characters')
    }),
    showBadgeLogo: yup.boolean()
  })
  .required()

export default appearanceFormValidationSchema
